module.exports = __webpack_public_path__ + "img/second-bg-mobile.6b434e11.jpg";